import { createFileRoute, redirect, stripSearchParams } from '@tanstack/react-router';
import { zodValidator, fallback } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { CALLBACK_ERRORS } from 'src/features/integrations/components/ConnectError';
import { getHasIntegrationSetup } from 'src/shared/lib/integration.utils';
import { IntegrationTypesWithFaker } from 'src/shared/types/integration.types';

export const integrationsSearchSchema = z.object({
  integration: fallback(z.string(), ''),
  tab: fallback(z.string(), ''),
  types: fallback(z.string(), ''),
  integrationStatus: fallback(z.string(), ''),
  automationPermission: fallback(z.string(), ''),
  groups: fallback(z.string(), ''),
  connected: fallback(z.string(), ''),
  error: fallback(z.string(), ''),
  connection_type: fallback(z.string(), ''),
  type: fallback(z.string(), ''),
});

const defaultIntegrationsSearch: IntegrationsSearch = {
  integration: '',
  tab: '',
  types: '',
  integrationStatus: '',
  automationPermission: '',
  groups: '',
  connected: '',
  error: '',
  connection_type: '',
  type: '',
};

export type IntegrationsSearch = z.infer<typeof integrationsSearchSchema>;

export const Route = createFileRoute('/_authenticated/integrations/')({
  validateSearch: zodValidator(integrationsSearchSchema),
  search: {
    middlewares: [stripSearchParams(defaultIntegrationsSearch)],
  },
  beforeLoad: ({ search }) => {
    const { error, connection_type, type } = search;
    if (error && connection_type === 'connect' && type) {
      const hasSetupFlow = getHasIntegrationSetup(type as IntegrationTypesWithFaker);
      if (hasSetupFlow && error in CALLBACK_ERRORS) {
        throw redirect({
          to: '/integrations/$type/setup',
          params: { type },
          search: { error },
        });
      }
    }
  },
});
